const $ = require("../../node_modules/jquery/dist/jquery.min")

module.exports = {
  init: () => {
    const burger = $(".header-burger")
    const closeButton = $(".asidemenu-close")
    const asideMenu = $(".asidemenu")

    const openAsideMenu = () => {
      asideMenu.addClass("asidemenu--active")
      return false
    }
    const closeAsideMenu = () => {
      asideMenu.removeClass("asidemenu--active")
      return false
    }

    $(document).on("click", function(e) {
      if ($(e.target).closest(".asidemenu").length === 0) {
        closeAsideMenu()
      }
    })
    burger.click(openAsideMenu)
    closeButton.click(closeAsideMenu)

    /*############## Menu handling ##############*/

    const trigger = $(".asidemenu-list-item-trigger")
    const expander = $(".asidemenu-list-item--expands")

    trigger.on("click", function() {
      const link = $(this)
      const element = link.closest(expander)

      link
        .parent()
        .parent()
        .find(".asidemenu-list-item--expanded")
        .not(element)
        .removeClass("asidemenu-list-item--expanded")

      $(this)
        .closest(expander)
        .toggleClass("asidemenu-list-item--expanded")
    })
  },
}
